// extracted by mini-css-extract-plugin
export var fileExt = "_v6-8";
export var fileIcon = "_v6-6";
export var fileLink = "_v6-5";
export var fileName = "_v6-7";
export var image = "_v6-1";
export var imageError = "_v6-3";
export var imageErrorIcon = "_v6-4";
export var imageLink = "_v6-0";
export var imageLoaded = "_v6-2";